import { useEffect, useState, type ReactNode } from "react";
import { fetchWorkspace } from "../api";
import { BASE_PATH, MOUNT_PATH } from "../basePath";
import { companyEntryPath } from "../../server/consoleUrlState";

/** A refreshed/new Clerk session may not have been available to the initial
 * document request. Resolve its company before mounting any console views. */
export function CompanyEntry({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(() => BASE_PATH !== MOUNT_PATH
    || new URLSearchParams(location.search).get("workspace") === "personal");
  useEffect(() => {
    if (ready) return;
    let cancelled = false;
    void fetchWorkspace(location.search).then(({ activeWorkspace }) => {
      if (cancelled) return;
      if (activeWorkspace.type === "team" && activeWorkspace.slug) {
        location.replace(companyEntryPath(new URL(location.href), activeWorkspace.slug, MOUNT_PATH));
        return;
      }
      setReady(true);
    }).catch(() => {
      // The shell already presents scoped/auth/network errors with retry.
      if (!cancelled) setReady(true);
    });
    return () => { cancelled = true; };
  }, [ready]);
  return ready ? children : <div role="status" data-testid="company-entry" style={{ padding: 32 }}>Opening workspace…</div>;
}
